// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


#exitButton{
    background-color: #FDDC79;
    border-radius: 100%;
    width: 40px;
    height: 40px;
    color: black;
    border-color: #FDDC79;
    font-size: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

}

#titleHeader{
    margin-top: 5%;
    display: flex;
    align-items: flex-end;
    padding-left: 6%;
}

#titleHeader h2{
    transform: translateX(20px);
    font-size: 24px;
}

.HeaderClass{
    height: 100px;
    display: flex;
    align-items: center;
}

.ButtonHeader:hover {
    color: black !important;
    background-color: transparent;
    border-color: transparent;
}

.ButtonHeader.active{
    color: black !important;
    background-color: transparent;
    border-color: transparent;

}

.ButtonHeader:first-child:active{
    color: black !important;
    background-color: transparent;
    border-color: transparent;
}
#BodyHeader{
    display: flex;
    width: 100%;
    height: 70px;
    justify-content: space-around;

    
}

#Notification{
    width: 8px;
    height: 8px;
    background-color: black;
    border-radius: 50%;
    position: relative;
    transform: translateX(13px);
}
.ButtonHeader{
    border: none;
    background-color: transparent;
    font-size: 17px;
    color: #797A7B;
}`, "",{"version":3,"sources":["webpack://./src/components__old/PrenotaHeader/PrenotaHeader.css"],"names":[],"mappings":";;;AAGA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;;AAE7B;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,6BAA6B;;;AAGjC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,cAAc;AAClB","sourcesContent":["\n\n\n#exitButton{\n    background-color: #FDDC79;\n    border-radius: 100%;\n    width: 40px;\n    height: 40px;\n    color: black;\n    border-color: #FDDC79;\n    font-size: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n}\n\n#titleHeader{\n    margin-top: 5%;\n    display: flex;\n    align-items: flex-end;\n    padding-left: 6%;\n}\n\n#titleHeader h2{\n    transform: translateX(20px);\n    font-size: 24px;\n}\n\n.HeaderClass{\n    height: 100px;\n    display: flex;\n    align-items: center;\n}\n\n.ButtonHeader:hover {\n    color: black !important;\n    background-color: transparent;\n    border-color: transparent;\n}\n\n.ButtonHeader.active{\n    color: black !important;\n    background-color: transparent;\n    border-color: transparent;\n\n}\n\n.ButtonHeader:first-child:active{\n    color: black !important;\n    background-color: transparent;\n    border-color: transparent;\n}\n#BodyHeader{\n    display: flex;\n    width: 100%;\n    height: 70px;\n    justify-content: space-around;\n\n    \n}\n\n#Notification{\n    width: 8px;\n    height: 8px;\n    background-color: black;\n    border-radius: 50%;\n    position: relative;\n    transform: translateX(13px);\n}\n.ButtonHeader{\n    border: none;\n    background-color: transparent;\n    font-size: 17px;\n    color: #797A7B;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
